import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { appRoutes } from './app.routes';
import { provideClientHydration } from '@angular/platform-browser';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideHttpClient, withFetch, withInterceptors, withInterceptorsFromDi } from '@angular/common/http';
import { environment } from '../environments/environment';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeng/themes/aura';

import { ApiBaseUrl } from '@mglsk/ng-core';
import { AuthConfig, provideOAuthClient } from 'angular-oauth2-oidc';
import { AuthService } from '@mglsk/ng-auth';

export const appConfig: ApplicationConfig = {
  providers: [
    provideAnimationsAsync(),
    providePrimeNG({
      theme: {
        preset: Aura,
      },
    }),
    provideClientHydration(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(appRoutes),
    provideHttpClient(withInterceptorsFromDi(), withInterceptors([]), withFetch()),
    provideOAuthClient({
      resourceServer: {
        allowedUrls: ['http://localhost/api', 'http://localhost:3000/api', 'https://staging-jobmatcher-api.eeeeee.be/api'], // TODO make configurable
        sendAccessToken: true,
      },
    }),
    {
      provide: AuthConfig,
      useValue: environment.authConfig,
    },
    { provide: ApiBaseUrl, useValue: environment.apiBaseUrl },
    { provide: AuthService, useClass: AuthService },
  ],
};
